import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SearchBarService } from 'src/app/shared/components/search-bar/search-bar.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { CustomEvent } from './custom-event.model';

@Injectable({
  providedIn: 'root',
})
export class CustomEventsService {
  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private searchBarService: SearchBarService,
    private httpClient: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}

  findAll() {
    return this.httpClient
      .get<CustomEvent[]>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/custom-events`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getCustomEvents = (): Observable<HttpResponse<CustomEvent[]>> => {
    const body = this.searchBarService.buildCriteria();
    return this.httpClient
      .post<CustomEvent[]>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/custom-events/search`, body, {
        observe: 'response',
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  };

  getCustomEvent(id: number): Observable<CustomEvent> {
    return this.httpClient
      .get<CustomEvent>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/custom-events/${id}`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  saveCustomEvent(customEvent: CustomEvent) {
    const { id, name, description } = customEvent;
    if (id) {
      return this.httpClient
        .put(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/custom-events/${id}`, { name, description })
        .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
    }
    return this.httpClient
      .post(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/custom-events`, { name, description })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  deleteCustomEvent(id: number) {
    return this.httpClient
      .delete(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/custom-events/${id}`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
